<!-- setType2Template -->
<template>
  <div class="setType2Template">
      <textBefore :ruleForm="ruleForm"></textBefore>
      <!-- <openPublishPush v-if="configInfo.openPublishPush" :ruleForm="ruleForm"></openPublishPush> -->
      <!-- <openReferencePush v-if="configInfo.openPublishPush" :ruleForm="ruleForm"></openReferencePush> -->
      <magCover :ruleForm="ruleForm"></magCover>
      <specialTopic :ruleForm="ruleForm"></specialTopic>
      <specialContent :ruleForm="ruleForm"></specialContent>
      <topic :ruleForm="ruleForm"></topic>
      <banner :ruleForm="ruleForm"></banner>
      <footerItem :ruleForm="ruleForm"></footerItem>
      <colourConfig :ruleForm="ruleForm"></colourConfig>
      <qrCode :ruleForm="ruleForm"></qrCode>
      <colourConfigOther :ruleForm="ruleForm"></colourConfigOther>
      <officialUrl :ruleForm="ruleForm"></officialUrl>
      <contactUs :ruleForm="ruleForm"></contactUs>
      <onlineSubmission :ruleForm="ruleForm"></onlineSubmission>
      <currentDiscuss :ruleForm="ruleForm"></currentDiscuss>
      <backIssueBrowsing :ruleForm="ruleForm"></backIssueBrowsing>
      <div class="form-row">
        <showColumn :ruleForm="ruleForm"></showColumn>
        <showArticleCover :ruleForm="ruleForm"></showArticleCover>
      </div>
    </div>
</template>

<script>
import textBefore from '../modules/textBefore.vue'
import magCover from '../modules/magCover.vue'
import specialTopic from '../modules/specialTopic.vue'
import specialContent from '../modules/specialContent.vue'
import topic from '../modules/topic.vue'
import banner from '../modules/banner.vue'
import footerItem from '../modules/footerItem.vue'
import colourConfig from '../modules/colourConfig.vue'
import colourConfigOther from '../modules/colourConfigOther.vue'
import qrCode from '../modules/qrCode.vue'
import contactUs from '../modules/contactUs.vue'
import onlineSubmission from '../modules/onlineSubmission.vue'
import currentDiscuss from '../modules/currentDiscuss.vue'
import backIssueBrowsing from '../modules/backIssueBrowsing.vue'
import showColumn from '../modules/showColumn.vue'
import showArticleCover from '../modules/showArticleCover.vue'
import officialUrl from '../modules/officialUrl.vue'
// import openPublishPush from '../modules/openPublishPush.vue'
// import openReferencePush from '../modules/openReferencePush.vue'
export default {
  name: 'setType2Template',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    configInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    textBefore,
    magCover,
    specialTopic,
    specialContent,
    topic,
    banner,
    footerItem,
    colourConfig,
    colourConfigOther,
    qrCode,
    contactUs,
    onlineSubmission,
    currentDiscuss,
    backIssueBrowsing,
    showColumn,
    showArticleCover,
    officialUrl
    // openPublishPush,
    // openReferencePush
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.form-row {
  display: flex;
  flex-direction: column;
  gap: 20px;
  .showColumn,
  .showArticleCover {
    flex: 1;
    min-width: 300px;
    width: 100%;
  }
}
</style>
